var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ns-tooltip-box"},_vm._l((_vm.tooltips),function(tooltip){return _c('ns-tooltip',{key:tooltip.id,attrs:{"id":tooltip.id,"left":tooltip.left,"top":tooltip.top,"hide":tooltip.hide}},[_vm._v(_vm._s(tooltip.text))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }